import { ApiService } from '@/api/services/core';
import { authApi } from '@/api';
import { AuthData, Credentials } from '@/api/services/userService/types';
import { ENDPOINTS } from '@/api/endpoints';

export class UserService extends ApiService {
  public login(props: Credentials) {
    return authApi.post<AuthData>(ENDPOINTS.auth.login, props);
  }

  public refresh(props: { refreshToken: string }) {
    return authApi.post<AuthData>(ENDPOINTS.auth.refresh, props);
  }
}
